import PropTypes from "prop-types";
import { memo } from "react";

import AppPropTypes from "../model/propTypes";

import NotificationIcon from "./NotificationIcon";

import "./RouteStopProgress.scss";

const propTypes = {
  hasNotification: PropTypes.bool,
  isBoarding: PropTypes.bool,
  isCancelled: PropTypes.bool,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  isLeft: PropTypes.bool,
  isNotificationEnd: PropTypes.bool,
  isNotificationStart: PropTypes.bool,
  isPassed: PropTypes.bool,
  lineInfos: AppPropTypes.lineInfos,
  nextHasNotification: PropTypes.bool,
  notification: PropTypes.object,
  previousHasNotification: PropTypes.bool,
  progress: PropTypes.number,
};

const disruptionTypeMapping = {
  DEVIATION: "rt-rect-vertical-notification-deviation",
  DEVIATION_STOPS: "rt-rect-vertical-notification-deviation-stops",
  DISRUPTION: "rt-rect-vertical-notification-disruption",
  DISRUPTION_RAIL_REPLACEMENT:
    "rt-rect-vertical-notification-disruption-rail-replacement",
};

function RouteStopProgress({
  hasNotification = false,
  isBoarding = false,
  isCancelled = false,
  isFirst = false,
  isLast = false,
  isLeft = false,
  isNotificationEnd = false,
  isNotificationStart = false,
  isPassed = false,
  lineInfos,
  nextHasNotification,
  notification,
  previousHasNotification,
  progress = 0,
}) {
  const defaultColor = "lightgray";
  const { stroke: color } = lineInfos || { stroke: "lightgray" };
  const isFirstOrLast = isFirst || isLast;
  const lineColor = color === "#ffffff" ? "black" : color;
  const routeColor = isPassed || isLeft ? defaultColor : lineColor;
  const hasMask = !isPassed;

  const bgColor = {
    backgroundColor: routeColor,
  };
  const borderColor = {
    borderColor: routeColor,
  };

  // Get the css values for the mask
  // For the first station the progress 0 start at the middle of the div.
  const top =
    isFirst || isNotificationEnd ? `${50 + progress / 2}%` : `${progress}%`;
  const height =
    isFirstOrLast || isNotificationEnd
      ? `${50 - progress / 2}%`
      : `${100 - progress}%`;

  return (
    <div className="rt-route-icon">
      {(!hasNotification ||
        (isNotificationStart &&
          !isNotificationEnd &&
          !previousHasNotification) ||
        (isNotificationEnd &&
          !isNotificationStart &&
          !nextHasNotification)) && (
        <>
          <div
            className="rt-rect-vertical"
            style={{
              backgroundColor: defaultColor,
              bottom: isLast && "50%",
              height: isFirstOrLast && "50%",
              top: (isFirst || isNotificationEnd) && "50%",
            }}
          />
          {hasMask && (
            <div
              className="rt-rect-vertical rt-rect-vertical-mask"
              style={{
                backgroundColor: lineColor,
                bottom: isLast && "50%",
                height,
                top,
              }}
            />
          )}
        </>
      )}
      {hasNotification && (
        <div
          className={`rt-rect-vertical rt-rect-vertical-notification${
            isNotificationStart && !previousHasNotification
              ? " rt-rect-vertical-notification-start"
              : ""
          }${
            isNotificationEnd && !nextHasNotification
              ? " rt-rect-vertical-notification-end"
              : ""
          } ${disruptionTypeMapping[notification.disruption_type]}`}
        >
          {isNotificationStart && (
            <NotificationIcon notification={notification} />
          )}
        </div>
      )}
      {isFirstOrLast && <div className="rt-rect-middle" style={bgColor} />}
      {!isFirstOrLast && !isCancelled && (
        <>
          <div
            className="rt-circle-middle"
            style={{
              borderColor: defaultColor,
            }}
          />
          {hasMask && (
            <div
              className={`rt-circle-middle rt-circle-middle-mask${
                isBoarding ? " pulse" : ""
              }`}
              style={borderColor}
            />
          )}
        </>
      )}
    </div>
  );
}

RouteStopProgress.propTypes = propTypes;

export default memo(RouteStopProgress);
